/**
 * BarChart.js
 *
 * @class   BarChart
 * @author  Dan Goldshlack
 *
 */

import React from 'react';
import D3 from 'd3';
import PropsJoin from '../../mixins/js/PropsJoin';
import Paper from '../../components/paper/Paper';

export default React.createClass({

	displayName: "BarChart",
	_chart_data: null,

	mixins: [ PropsJoin ],

	propTypes: {
		className: React.PropTypes.string,
		data: function(props, propName, componentName) {
			if (!props.data) {
				return new Error('Warning: Required prop `data` was not specified in `' + componentName + '`.')
			}
		},
		onMouseDown: React.PropTypes.func,
		onMouseUp: React.PropTypes.func,
		onMouseOut: React.PropTypes.func,
		onTouchEnd: React.PropTypes.func,
		onTouchStart: React.PropTypes.func,
		primary: React.PropTypes.bool,
		secondary: React.PropTypes.bool
	},

	getInitialState() {
		let zDepth = this.props.disabled ? 0 : 1;
		return {
			zDepth: zDepth,
			initialZDepth: zDepth
		};
	},

	componentWillReceiveProps(nextProps) {
		let zDepth = nextProps.disabled ? 0 : 1;
		this.setState({
			zDepth: zDepth,
			initialZDepth: zDepth
		});
	},

	renderChart() {
		switch(this.props.direction) {
			case 'vertical':
				this.renderChartVertical();
				break;
			case 'horizontal':
			/* falls through */
			default:
				this.renderChartHorizontal();
				break;
		}
	},

	renderChartVertical() {

		let _this = this;

		let margin = {top: 20, right: 30, bottom: 30, left: 40},
			width = 960 - margin.left - margin.right,
			height = 500 - margin.top - margin.bottom;

		let x = d3.scale.ordinal()
			.rangeRoundBands([0, width], .1);

		let y = d3.scale.linear()
			.range([height, 0]);

		let xAxis = d3.svg.axis()
			.scale(x)
			.orient("bottom");

		let yAxis = d3.svg.axis()
			.scale(y)
			.orient("left");

		let chart = d3.select(".chart-" + this.props.direction)
			.attr("width", width + margin.left + margin.right)
			.attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		let data = _this._chart_data;

		x.domain(data.map(function(d) { return d.name; }));
		y.domain([0, d3.max(data, function(d) { return d.value; })]);

		chart.append("g")
			.attr("class", "x axis")
			.attr("transform", "translate(0," + height + ")")
			.call(xAxis);

		chart.append("g")
			.attr("class", "y axis")
			.call(yAxis);

		chart.selectAll(".bar")
			.data(data)
			.enter().append("rect")
			.attr("class", "bar")
			.attr("x", function(d) { return x(d.name); })
			.attr("y", function(d) { return y(d.value); })
			.attr("height", function(d) { return height - y(d.value); })
			.attr("width", x.rangeBand());

		function type(d) {
			d.value = +d.value; // coerce to number
			return d;
		}
	},

	renderChartHorizontal() {

		let _this = this;

		let width = 420,
			barHeight = 20;

		let x = d3.scale.linear()
			.range([0, width]);

		let chart = d3.select(".chart-" + this.props.direction)
			.attr("width", width + 25);

		let data = _this._chart_data;

		x.domain([0, d3.max(data, function(d) { return d.value; })]);

		chart.attr("height", barHeight * data.length);

		let bar = chart.selectAll("g")
			.data(data)
			.enter().append("g")
			.attr("transform", function(d, i) { return "translate(0," + i * barHeight + ")"; });

		bar.append("rect")
			.attr("width", function(d) { return x(d.value); })
			.attr("height", barHeight - 1);

		bar.append("text")
			.attr("x", function(d) { return x(d.value) - 3; })
			.attr("y", barHeight / 2)
			.attr("dy", ".35em")
			.text(function(d) { return d.value; });

		function type(d) {
			d.value = +d.value; // coerce to number
			return d;
		}

	},

	render() {

		let _this = this;

		_this._chart_data = [];
		for(var key in _this.props.data) {
			var item = _this.props.data[key];
			if (typeof(item) !== 'object' || !('value' in item)) {
				item = {
					name: item,
					value: item
				}
			}
			_this._chart_data.push(item);
		}

		setTimeout(function() {
			_this.renderChart();
		}, 15);

		let className = "chart chart-" + this.props.direction;

		return (
			<div>
				<h3>Bar Chart</h3>
				<svg className={className}
					onMouseUp={this._handleMouseUp}
					onMouseDown={this._handleMouseDown}
					onMouseOut={this._handleMouseOut}
					onTouchStart={this._handleTouchStart}
					onTouchEnd={this._handleTouchEnd}>
				</svg>
			</div>
		);
	},

	onResize() {

		this.render();

	},

	_handleMouseDown(e) {
		//only listen to left clicks
		if (e.button === 0) {
			this.setState({
				zDepth: this.state.initialZDepth + 1
			});
		}
		if (this.props.onMouseDown) this.props.onMouseDown(e);
	},

	_handleMouseUp(e) {
		this.setState({
			zDepth: this.state.initialZDepth
		});
		if (this.props.onMouseUp) this.props.onMouseUp(e);
	},

	_handleMouseOut(e) {
		this.setState({
			zDepth: this.state.initialZDepth
		});
		if (this.props.onMouseOut) this.props.onMouseOut(e);
	},

	_handleTouchStart(e) {
		this.setState({
			zDepth: this.state.initialZDepth + 1
		});
		if (this.props.onTouchStart) this.props.onTouchStart(e);
	},

	_handleTouchEnd(e) {
		this.setState({
			zDepth: this.state.initialZDepth
		});
		if (this.props.onTouchEnd) this.props.onTouchEnd(e);
	}

});



/** WEBPACK FOOTER **
 ** ./src/charts/bar-chart/BarChart.js
 **/